/*
 * @providesModule LiveEventRecapPLOW
 *
 */
export default function LiveEventRecapPLOW() {
    return <></>;
}
